import React, { useState } from "react";
import { Radio } from "@mui/material"; // or wherever your Radio is from
import styles from "./RedressAssociate.module.css";
import { translate } from "../../../../../../common/providers";
import { isNonEmptyObject } from "../../../../../../common/utils";
import { CustomButton } from "../../../../../../common/components";

const WORD_LIMIT = 100;

type InformationContent = {
	allContent?: string;
};

type Information = {
	informationId: number;
	content?: InformationContent;
};

interface InformationBlockProps {
	information: Information | null;
	selectedInformation: number | null;
	onSelect: (info: Information) => void;
	disabled?: boolean;
	labelTranslateKey: string;
}

const truncateWords = (text: string, wordLimit: number) => {
	const words = text.split(/\s+/);
	if (words.length <= wordLimit) return text;
	return `${words.slice(0, wordLimit).join(" ")}...`;
};

const InformationBlock: React.FC<InformationBlockProps> = ({
	information,
	selectedInformation,
	onSelect,
	disabled = false,
	labelTranslateKey,
}) => {
	const [expanded, setExpanded] = useState(false);
	if (!isNonEmptyObject(information) || !information) {
		return null;
	}
	const text = information.content?.allContent || "";
	const needsTruncate = text.split(/\s+/).length > WORD_LIMIT;
	const handleToggle = () => setExpanded((prev) => !prev);
	return (
		<div className={styles[disabled ? "currentInformation" : "neighborInformation"]}>
			<div>
				<Radio
					checked={selectedInformation === information.informationId}
					disabled={disabled}
					onChange={() => onSelect(information)}
				/>
			</div>
			<div>
				{translate(labelTranslateKey, { infoId: information.informationId })}
				{expanded || !needsTruncate ? text : truncateWords(text, WORD_LIMIT)}
				{needsTruncate && (
					<CustomButton className={styles.collapseText} onClick={handleToggle}>
						{expanded ? translate("common:btn.see-less") : translate("common:btn.see-more")}
					</CustomButton>
				)}
			</div>
		</div>
	);
};

export default InformationBlock;
